import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FlexModule } from "@vp/shared/directives/flex";
import { SpinnerModule } from "@vp/shared/spinner";
import { DeviceCommandListModule } from "@vp/virtual-care/ui/device-command-list";
import { AdvancedCommandsComponent } from "./components/advanced-commands.component";
import { AdvancedCommandsDialogComponent } from "./components/advanced-commands-dialog/advanced-commands-dialog.component";
import { MatListModule } from "@angular/material/list";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [AdvancedCommandsComponent, AdvancedCommandsDialogComponent],
  imports: [
    CommonModule,
    DeviceCommandListModule,
    FlexModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ReactiveFormsModule,
    SpinnerModule
  ],
  exports: [AdvancedCommandsComponent, AdvancedCommandsDialogComponent]
})
export class AdvancedCommandsModule {}
